/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import Frames from './Frames';
import Mats from './Mats';
import Glass from './Glass';
import WallColor from './WallColor';
import RoomView from './RoomView';
import Printing from './Printing';
import Layout from './Layout';
import Sizes from './Sizes';
import Plaque from './Plaque';
import FramePopUp from '../Components/Modal/FramePopUp';
import MediaQuery from 'react-responsive';
import Parser from 'html-react-parser';
import {getCanvasData} from '../Helpers/Helpers';

class Tabs extends Component {

  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSelect(key) {
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        selectedTab: key
      }
    })
  }

  render() {
    const {selectedmatBoard} = this.props;
    return (
      <div className="attr_sect full_width">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <Tab.Container className="tab_1" activeKey={this.props.selectedTab} defaultActiveKey="layout" id="tab-container-frame" onSelect={this.handleSelect}>
                <div className="tabbable-panel">
                  <div className="tabbable-line">
                    <Nav bsStyle="tabs">
                      <NavItem eventKey="layout">Layout</NavItem>
                      <NavItem eventKey="sizes">Sizes</NavItem>
                      <NavItem eventKey="mats">Colours</NavItem>
                      <NavItem eventKey="printing">Printing</NavItem>
                      <NavItem eventKey="plaque">Plaque Text</NavItem>
                      <NavItem eventKey="frames">Frames</NavItem>
                      <NavItem eventKey="glass">Glass</NavItem>
                      <NavItem eventKey="wallcolor">WallColor</NavItem>
                      <NavItem eventKey="roomview">Room View</NavItem>
                    </Nav>
                    <MediaQuery minDeviceWidth={768}>
                      {selectedmatBoard.size > 0 ?
                        <div className="sel_img">
                          <p>
                            <a href="#!" className="right" onClick={this.handleShow}>Currently Selected <i><img src={getCanvasData(selectedmatBoard)} alt={Parser(selectedmatBoard.get('name'))} /></i></a>
                          </p>
                          <FramePopUp {...this.props} show={this.state.show} onHide={this.handleClose} />
                        </div>
                        : ''
                      }
                    </MediaQuery>
                    <div className="tab-content">
                      <div className="tab-pane active">
                        <div className="in_tabs">
                          <div className="tab-content">
                            <div className="tab-pane active tb_cont" id="all">
                              <Tab.Content>
                                <Tab.Pane eventKey="layout">
                                  <Layout {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="sizes">
                                  <Sizes title={true} hasUpdate={false} {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="mats">
                                  <Mats {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="plaque">
                                  <Plaque {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="frames">
                                  <Frames {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="glass">
                                 <Glass {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="printing">
                                  <Printing {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="wallcolor">
                                  <WallColor {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="roomview">
                                  <RoomView {...this.props} />
                                </Tab.Pane>
                              </Tab.Content>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Tabs;